import { render, staticRenderFns } from "./ConsultarAviso.vue?vue&type=template&id=47c18410"
import script from "./ConsultarAviso.vue?vue&type=script&lang=ts"
export * from "./ConsultarAviso.vue?vue&type=script&lang=ts"
import style0 from "./ConsultarAviso.vue?vue&type=style&index=0&id=47c18410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports